const formatCurrency = (amount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  return formatter.format(amount);
};

const formatToPrecision = (number, precision = 2) => {
  return parseFloat(number.toFixed(precision));
}


export { formatCurrency, formatToPrecision };

